import * as React from "react";
function SvgBubbleLines(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M29 23h-4v6l-6-6H3a2 2 0 01-2-2V5a2 2 0 012-2h26a2 2 0 012 2v16a2 2 0 01-2 2zM7 9h18M7 13h18M7 17h12"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbleLines);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
